import { render, staticRenderFns } from "./Saa.vue?vue&type=template&id=4cac3fd2&scoped=true"
import script from "./Saa.vue?vue&type=script&lang=js"
export * from "./Saa.vue?vue&type=script&lang=js"
import style0 from "./Saa.vue?vue&type=style&index=0&id=4cac3fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cac3fd2",
  null
  
)

export default component.exports